import React from 'react';
import PropTypes from 'prop-types';
import classNames from '@jd/jmtd-tools/es/classnames';
import Popover from '../Popover';

function Tooltip(_ref) {
  var title = _ref.title,
      _ref$visibility = _ref.visibility,
      visibility = _ref$visibility === void 0 ? title != null && title !== '' : _ref$visibility,
      children = _ref.children,
      theme = _ref.theme,
      placement = _ref.placement,
      className = _ref.className,
      mouseEnterDelay = _ref.mouseEnterDelay,
      mouseLeaveDelay = _ref.mouseLeaveDelay,
      mouseThrough = _ref.mouseThrough,
      arrowPointAtCenter = _ref.arrowPointAtCenter,
      open = _ref.open,
      trigger = _ref.trigger;

  function stopPropagation(e) {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
  }

  return /*#__PURE__*/React.createElement(Popover, {
    placement: placement,
    visibility: visibility,
    mouseEnterDelay: mouseEnterDelay,
    mouseLeaveDelay: mouseLeaveDelay,
    arrowPointAtCenter: arrowPointAtCenter,
    open: open,
    trigger: trigger,
    showArrow: true,
    portalClassName: "jmtd-tooltip-portal",
    popoverClassName: classNames('jmtd-tooltip', className, {
      'jmtd-tooltip-title': mouseThrough,
      'jmtd-tooltip-theme-dark': theme === 'dark',
      'jmtd-tooltip-theme-light': theme === 'light'
    }),
    popover: /*#__PURE__*/React.createElement("div", {
      onMouseDown: stopPropagation,
      onClick: stopPropagation,
      onMouseUp: stopPropagation,
      className: "jmtd-tooltip-content"
    }, title)
  }, children);
}

Tooltip.propTypes = {
  trigger: PropTypes.oneOf(['click', 'hover', 'control']),
  open: PropTypes.bool,
  className: PropTypes.string,
  theme: PropTypes.oneOf(['light', 'dark']),
  placement: PropTypes.oneOf(['top', 'topLeft', 'topRight', 'left', 'leftTop', 'leftBottom', 'bottom', 'bottomLeft', 'bottomRight', 'right', 'rightTop', 'rightBottom']),
  title: PropTypes.node,
  mouseEnterDelay: PropTypes.number,
  mouseLeaveDelay: PropTypes.number,
  children: PropTypes.element.isRequired,
  visibility: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  arrowPointAtCenter: PropTypes.bool,
  mouseThrough: PropTypes.bool
};
Tooltip.defaultProps = {
  mouseThrough: false,
  trigger: 'hover',
  open: false,
  className: '',
  // tooltip内容自定义class（tooltip是插入到body中）
  theme: 'dark',
  // tooltip主题颜色 light dark
  placement: 'top',
  // top,topLeft,topRight,left,leftTop,leftBottom,bottom,bottomLeft,bottomRight,right,rightTop,rightBottom
  title: null,
  // tooltip显示文案
  mouseEnterDelay: 0,
  // 鼠标划入延迟多长时间显示tooltip（单位：ms）
  mouseLeaveDelay: 300,
  // 鼠标划出延迟多长时间显示tooltip（单位：ms）
  visibility: undefined,
  arrowPointAtCenter: false
};
export default Tooltip;